import { useEffect, ReactNode, useRef } from 'react';

import { SplashScreen } from 'src/components/loading-screen';
import { useMeStore } from 'src/store/me/me.store';

import { useAuth } from '../hooks/use-auth';
import { useTokenRefresh } from '../hooks/use-token-refresh';
import { useAuthStore } from '../store/auth.store';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
};

export default function AuthProvider({ children }: Props) {
  const { isLoading } = useAuthStore();
  const { initializeAuth } = useAuth();
  const isInitialized = useRef(false);

  // Hook que verifica e renova o token periodicamente
  useTokenRefresh();

  useEffect(() => {
    // Garantir que a inicialização ocorre apenas uma vez
    if (!isInitialized.current) {
      isInitialized.current = true;
      initializeAuth();
    }
  }, [initializeAuth]);

  // Sincronizar dados do usuário quando autenticado
  useEffect(() => {
    const { isAuthenticated } = useAuthStore.getState();
    if (isAuthenticated) {
      const { me } = useMeStore.getState();
      // Só busca dados se ainda não tiver dados do usuário
      if (!me) {
        // getMyData(); // Descomentar quando implementar
      }
    }
  }, []);

  if (isLoading) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
